import React from "react"
import {RefTable, DefaultProps} from "../RefTable"

export const Checkout = (props)=><RefTable {...props}/>;

Checkout.defaultProps = {
    ...DefaultProps,
    title: "Checkouts",
    tableSchema: "checkouts",
    tableName: "checkouts",
    edit: true,
}
